<template xmlns:v-touch="http://www.w3.org/1999/xhtml">
  <v-container :fill-height="loading" class="vastuualue-asetukset-view" fluid pt-0>
    <v-app-bar app color="black" dark fixed>

      <template v-if="$vuetify.breakpoint.mdAndDown">
        <hb-main-menu-button/>
      </template>

      <v-toolbar-title v-if="!loading" style="margin-left: 0">{{ $tc('vastuualue.title', 2) }}</v-toolbar-title>

      <v-spacer></v-spacer>
    </v-app-bar>

    <hb-loading-indicator v-if="loading" align-middle fill-height></hb-loading-indicator>

    <v-fade-transition hide-on-leave>
      <v-row v-if="!loading">
        <v-col class="mt-2" cols="12" offset-xl="1" xl="10">
          <v-row>
            <v-col cols="12">
              <v-card color="#191919">
                <v-card-title>
                  {{ $tc('vastuualue.title', 2) }}
                  <v-spacer></v-spacer>
                  <v-btn color="primary" icon @click="openEdit(null)">
                    <v-icon>mdi mdi-plus</v-icon>
                  </v-btn>
                </v-card-title>
                <v-data-table :headers="headers" :items="vastuualueet" disable-pagination
                              hide-default-footer
                >
                  <template v-slot:item.logo="{item}">
                    <v-list-item-avatar class="pa-1" color="grey" size="100" tile>
                      <v-img v-if="item.logo" :src="item.logo" contain></v-img>
                    </v-list-item-avatar>

                  </template>
                  <template v-slot:item.aktiivinen="{item}">
                    {{ item.aktiivinen ? $t('yes') : $t('no') }}
                  </template>
                  <template v-slot:item.vastuuuser="{item}">
                    {{ item.vastuuuser && item.vastuuuser.firstname }}
                    {{ item.vastuuuser && item.vastuuuser.lastname }}
                  </template>
                  <template v-slot:item._="{item}">
                    <v-btn icon @click="openEdit(item)">
                      <v-icon small>mdi mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card>
              <v-dialog v-model="showEditDialog" max-width="600">
                <v-card>
                  <v-card-title primary-title>
                    {{ $tc('vastuualue.title', 1) }}
                  </v-card-title>
                  <v-divider/>
                  <v-card-text>
                    <v-row>
                      <v-col class="mt-2" cols="12">
                        <v-form ref="form">
                          <v-text-field v-model="edit.nimi"
                                        :disabled="saving"
                                        :label="$t('vastuualue.nimi')"
                                        :rules="[$rules.required]"
                                        class="required"
                                        type="text"
                                        validate-on-blur></v-text-field>
                          <v-autocomplete v-model="edit.vastuuuserId"
                                          :disabled="saving"
                                          :item-text="(item) => item.firstname + ' ' + item.lastname"
                                          :items="users"

                                          :label="$t('vastuualue.vastuuuser')"
                                          :rules="[$rules.required]"
                                          class="required"
                                          item-value="id"
                                          validate-on-blur
                          ></v-autocomplete>
                          <v-file-input v-model="edit._logo" :label="$t('vastuualue.logo')"></v-file-input>
                          <v-img v-if="!edit._logo && edit.logo" :src="edit.logo" max-width="250"/>
                          <v-text-field v-model.number="edit.jarjestysnumero"
                                        :disabled="saving"
                                        :label="$t('vastuualue.jarjestysnumero')"
                                        class="mt-2"
                                        type="number"
                                        validate-on-blur></v-text-field>
                          <v-switch v-model="edit.aktiivinen"
                                    :disabled="saving"
                                    :label="$t('vastuualue.aktiivinen')"
                          ></v-switch>
                        </v-form>

                      </v-col>
                    </v-row>


                  </v-card-text>
                  <v-divider/>
                  <v-card-actions>
                    <v-spacer/>
                    <v-btn color="default" @click="closeDialog">{{ $t('cancel') }}</v-btn>
                    <v-btn :loading="saving" color="primary" @click="save">{{ $t('save') }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-fade-transition>
  </v-container>
</template>

<script>
import api from '../apicollection';
import apicollection from '../apicollection';

export default {
  name: 'VastuualueAsetuksetView',
  data() {
    return {
      loading: true,
      vastuualueet: [],
      users: [],
      edit: {},
      saving: false,
      showEditDialog: false,
      headers: [
        {
          text: this.$t('vastuualue.nimi'),
          value: 'nimi'
        },
        {
          text: this.$t('vastuualue.vastuuuser'),
          value: 'vastuuuser'
        },
        {
          text: this.$t('vastuualue.logo'),
          value: 'logo'
        },
        {
          text: this.$t('vastuualue.jarjestysnumero'),
          value: 'jarjestysnumero'
        },
        {
          text: this.$t('vastuualue.aktiivinen'),
          value: 'aktiivinen'
        },
        {
          text: '',
          value: '_'
        }
      ]
    };
  },
  computed: {},
  methods: {
    async getVastuualueet() {
      const vastuualueet = await api.getVastuualueetFull();
      this.vastuualueet = vastuualueet;
    },
    async getUsers() {
      const users = await api.getUsers();
      this.users = users;
    },
    openEdit(item) {
      this.showEditDialog = true;
      this.edit = {...item} || {};
    },
    closeDialog() {
      this.showEditDialog = false;
    },
    async save() {
      const vastuualue = {...this.edit};
      if (!this.$refs.form.validate()) return;
      this.saving = true;

      if (vastuualue._logo) {
        vastuualue.logo = await this.$fileToBase64(vastuualue._logo);
      }
      try {
        if (vastuualue.id) {
          await apicollection.updateVastuualue(vastuualue);
        } else {
          await apicollection.createVastuualue(vastuualue);
        }

        this.closeDialog();
        this.getVastuualueet();
      } catch (e) {
        this.$showErrorNotification(this.$t('errors.error_saving_vastuualue'))
      } finally {
        this.saving = false;
      }
    }
  },
  async mounted() {
    await Promise.all([this.getVastuualueet(), this.getUsers()])

    this.loading = false;


    this.$vuetify.goTo(0, {
      duration: 0,
      offset: 0,
    });
  },
};
</script>

<style lang="scss" scoped></style>
